import { animate, animateChild, query, stagger, style, transition, trigger } from '@angular/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SignatureStepDto } from 'src/app/models/dtos/annexes/signature-step-dto';

@Component({
  selector: 'app-annex-approval-progress',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule],
  providers: [DatePipe],
  templateUrl: './annex-approval-progress.component.html',
  styleUrl: './annex-approval-progress.component.scss',
  animations: [
    trigger('list', [
      transition(':enter, * => *', [
        query('@step', stagger(80, animateChild()), { optional: true }),
        query('@connector', stagger(80, animateChild()), { optional: true })
      ])
    ]),
    trigger('step', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(6px) scale(0.98)' }),
        animate('240ms cubic-bezier(0.2, 0, 0, 1)',
          style({ opacity: 1, transform: 'none' }))
      ]),
      transition(':leave', [
        animate('180ms ease-in',
          style({ opacity: 0, transform: 'translateY(-6px) scale(0.98)' }))
      ])
    ]),
    trigger('connector', [
      transition(':enter', [
        style({ transform: 'scaleX(0)' }),
        animate('300ms 80ms ease-out', style({ transform: 'scaleX(1)' }))
      ]),
      transition(':leave', [
        animate('160ms ease-in', style({ transform: 'scaleX(0)' }))
      ])
    ])
  ]
})
export class AnnexApprovalProgressComponent implements OnChanges, AfterViewInit {
  @Input() signatureSteps: SignatureStepDto[] = [];

  steps: SignatureStepDto[] = [];
  private readonly cdr = inject(ChangeDetectorRef);

  public initialRender = true;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initialRender = false;
      this.cdr.markForCheck();
    });
  }

  ngOnChanges(): void {
    this.steps = [...(this.signatureSteps ?? [])].sort((a, b) => a.order - b.order);
  }

  trackById(index: number, s: { id: number }): number {
    return s.id;
  }

  getSignaturesCountText(s: SignatureStepDto): string {
    const signed = s.signedQuantity ?? 0;
    const required = s.requiredQuantity ?? 0;
    return `(${signed}/${required})`;
  }
}
